/* Alpine JS */
import Alpine from 'alpinejs'

/* Masker voor input velden. Docs: https://alpinejs.dev/plugins/mask (comment uit om te gebruiken) */
// import mask from '@alpinejs/mask'
// Alpine.plugin(mask)

/* Viewport wachter. Docs: https://alpinejs.dev/plugins/intersect (comment uit om te gebruiken) */
// import intersect from '@alpinejs/intersect'
// Alpine.plugin(intersect)

/* Sla data op in LocalStorage. Docs: https://alpinejs.dev/plugins/persist (comment uit om te gebruiken) */
// import persist from '@alpinejs/persist'
// Alpine.plugin(persist)

/* Focus management (WCAG). Docs: https://alpinejs.dev/plugins/focus (comment uit om te gebruiken) */
// import focus from '@alpinejs/focus'
// Alpine.plugin(focus)

/* Geanimeerde collapse, handig voor accorion. Docs: https://alpinejs.dev/plugins/collapse (comment uit om te gebruiken) */
import collapse from '@alpinejs/collapse'
Alpine.plugin(collapse)

/* https://alpinejs.dev/plugins/morph (comment uit om te gebruiken) */
// import morph from '@alpinejs/morph'
// Alpine.plugin(morph)

/* External: Alpine JS plugins: */
import tooltip from "@ryangjchandler/alpine-tooltip"; // Tooltip plugin o.b.v. Tippy JS. Docs: https://github.com/ryangjchandler/alpine-tooltip
Alpine.plugin(tooltip);

window.Alpine = Alpine  // add to window, to make globally available

// Start Alpine JS
Alpine.start()